const rawDemoFlag = (process.env.REACT_APP_DEMO_MODE ?? 'false').toString().toLowerCase()

const DEMO_WIZARD_STEP_LIMIT = 6

export const isDemoMode = rawDemoFlag === 'true'

export const DEMO_SECTIONS = {
  ASIDE_PROJECT_SELECTOR: 'project-selector',
  ASIDE_PROJECT_SEPARATOR: 'project-selector-separator',
  MENU_DASHBOARD: 'menu-dashboard',
  MENU_PROJECT_SETUP: 'menu-project-setup',
  MENU_PROJECT_DETAILS: 'menu-project-details',
  MENU_CASHFLOW: 'menu-cashflow',
  MENU_BUDGET: 'menu-budget',
  MENU_MILESTONES: 'menu-milestones',
  MENU_DOCUMENT_REGISTRY: 'menu-document-registry',
  MENU_CONTACTS: 'menu-contacts',
  MENU_REPORTS: 'menu-reports',
  MENU_REPORTS_VARIATION: 'menu-reports-variation-assessments',
  MENU_REPORTS_PROGRESS: 'menu-reports-progress-claim',
  MENU_REPORTS_PCG: 'menu-reports-pcg-report',
  MENU_ADMINISTRATION: 'menu-administration',
  MENU_ADMIN_USERS: 'menu-administration-users',
  MENU_ADMIN_ROLES: 'menu-administration-roles',
  MENU_ADMIN_SETTINGS: 'menu-administration-settings',
  MENU_ADMIN_AUDIT: 'menu-administration-audit',
  MENU_ADMIN_AUDIT_LOGS: 'menu-administration-audit-logs',
} as const

export const isDemoSectionVisible = (sectionId?: string): boolean => {
  return true; // Demo mode would now show all sections
}

export const getDemoSectionAttributes = (sectionId?: string) =>
  sectionId
    ? ({
        'data-demo-section': sectionId,
      } as const)
    : undefined

export const initializeDemoMode = () => {
  if (typeof document === 'undefined') {
    return
  }
  document.body.classList.toggle('demo-mode', isDemoMode)
}

export const getDemoWizardStepLimit = (): number | undefined => {
  if (!isDemoMode) {
    return undefined
  }
  return DEMO_WIZARD_STEP_LIMIT
}
